export default __webpack_public_path__ + "static/media/rami-hod.fceabcdc.png";